/**
 * BLU-1541: per-SKU push rules (Skip / Always 0).
 *
 * The tRPC `cause.code` the backend sets when a save would take the org's
 * lists past the cap, and the frontend matches on. Registered for forwarding
 * in the backend's `FORWARDABLE_CAUSE_CODES` (trpc.ts).
 */
export const PUSH_SKU_RULES_CAP_EXCEEDED = 'PUSH_SKU_RULES_CAP_EXCEEDED';
/** Most SKU ids the Skip and Always 0 lists may hold together (enforced by the `set_push_sku_rules` RPC). */
export const PUSH_SKU_RULES_CAP = 5000;
/** The push's zero-stock threshold when the org never set one (`inventoryPush.zeroStockThreshold`). */
export const DEFAULT_ZERO_STOCK_THRESHOLD = 10;
/** Most Always 0 rows one scheduled push takes to 0 when the org never set `inventoryPush.alwaysZeroLimit`. */
export const DEFAULT_ALWAYS_ZERO_LIMIT = 200;
/** Largest `inventoryPush.alwaysZeroLimit` the settings accept. */
export const MAX_ALWAYS_ZERO_LIMIT = 100000;
/**
 * Rows set to Always 0 skip the mass zero-stock guard, so a scheduled push
 * halts when more of them than this many would go from in stock to 0 at once.
 * Read off `inventoryPush.alwaysZeroLimit`: absent is 200, and 0 means No
 * limit (null here). Independent of `zeroStockThreshold`.
 */
export function alwaysZeroCeiling(pushSettings) {
    const limit = pushSettings?.alwaysZeroLimit;
    return limit === 0 ? null : (limit ?? DEFAULT_ALWAYS_ZERO_LIMIT);
}
/**
 * Which guard halted a scheduled push (`settings.inventoryPush.halted.kind`).
 * A halt written before the field existed has no kind and is treated as today.
 * `always_zero_ceiling`: too many SKUs set to Always 0 would go to 0 at once;
 * dismissing it clears the halt and marks nothing.
 */
export const PUSH_HALT_KINDS = ['mass_zero', 'approval_queue', 'always_zero_ceiling'];
